module.exports = __webpack_public_path__ + "static/media/Nut.1a9712c6.jpg";